import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../services';

@Component({
  selector: 'main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {

  userName: String;
  groupName: String;
  storageName: String;

  routes: Object[] = [
  ];

  constructor(private _router: Router,
    private authenticationService: AuthenticationService, ) { }

  ngOnInit() {
    this.authenticationService.getUserName().subscribe(message => { this.userName = message; });
    this.authenticationService.getGroupName().subscribe(message => { this.groupName = message; });
    this.storageName = this.authenticationService.getStorageName();
    this.routes.push({
      title: 'Home',
      route: '/status',
      icon: 'apps'
    });
    this.routes.push({
      title: 'Storage manager',
      route: '/storage',
      icon: 'apps'
    });
    this.routes.push({
      title: 'Einlagern / Store',
      route: '/stockup',
      icon: 'apps'
    });
    this.routes.push({
      title: 'Manifest erstellen / Create manifest',
      route: '/manifestchoice',
      icon: 'apps'
    });
    this.routes.push({
      title: 'E-Comm (GAS)',
      route: '/gaschoice',
      icon: 'apps'
    });
    this.routes.push({
      title: 'Container manager',
      route: '/container',
      icon: 'apps'
    });
    this.routes.push({
      title: 'Shelf manager',
      route: '/shelf',
      icon: 'apps'
    });
    this.routes.push({
      title: 'Exception manager',
      route: '/exception',
      icon: 'apps'
    });
    this.routes.push({
      title: 'Sorter Configuration',
      route: '/sorter',
      icon: 'apps'
    });
  }

  logout(): void {
    this.authenticationService.logout();
    this._router.navigate(['/login']);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/main/main.component.ts